<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.4359 32.5L30.6859 24.1243H27.1859V18.5406L21.9359 26.9162H25.4359V32.5Z" class="fill-current" />
    <path
      d="M11.9087 25.7742C8.59498 25.7742 5.90869 23.0469 5.90869 19.6828C5.90869 16.3186 8.59498 13.5914 11.9087 13.5914C12.7455 13.5914 13.5424 13.7653 14.266 14.0795C15.3556 10.278 18.8126 7.5 22.9087 7.5C27.8793 7.5 31.9087 11.5908 31.9087 16.6371C31.9087 16.9804 31.89 17.3192 31.8537 17.6527L31.9087 17.6523C34.1178 17.6523 35.9087 19.4704 35.9087 21.7132C35.9087 23.956 34.1178 25.7742 31.9087 25.7742H31.1333L32.9629 22.8553H28.4358V14.1826L21.17 25.7742H11.9087Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3786 30.703L18.8786 26.8959L20.4387 27.9518L17.9387 31.7589L16.3786 30.703Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0036 30.703L14.5036 26.8959L16.0637 27.9518L13.5637 31.7589L12.0036 30.703Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.62864 30.703L10.1286 26.8959L11.6887 27.9518L9.18874 31.7589L7.62864 30.703Z"
      class="fill-current"
    />
  </svg>
</template>
